import { Layers, warn } from 'cc';

enum UserLayers {
    UserLayer0 = 1 << 0,
    UserLayer1 = 1 << 1,
    UserLayer2 = 1 << 2,
    UserLayer3 = 1 << 3,
    UserLayer4 = 1 << 4,
    UserLayer5 = 1 << 5,
    UserLayer6 = 1 << 6,
    UserLayer7 = 1 << 7,
    UserLayer8 = 1 << 8,
    UserLayer9 = 1 << 9,
    UserLayer10 = 1 << 10,
    UserLayer11 = 1 << 11,
    UserLayer12 = 1 << 12,
    UserLayer13 = 1 << 13,
    UserLayer14 = 1 << 14,
    UserLayer15 = 1 << 15,
    UserLayer16 = 1 << 16,
    UserLayer17 = 1 << 17,
    UserLayer18 = 1 << 18,
    UserLayer19 = 1 << 19,
}
const userLayers = Object.values(UserLayers).filter((v) => typeof v === 'number') as UserLayers[];

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    namespace Layers {
        export function getUnusedUserLayer(layerName?: string): number;
        export function freeLayer(layer: number): void;
        export function isUserLayer(layer: number): boolean;
        export function isLayerUsed(layer: number): boolean;
        // eslint-disable-next-line import/no-mutable-exports
        export let unusedLayerCount: number;
    }
}

Layers.getUnusedUserLayer = function getUnusedLayer(this: Layers, layerName?: string): number {
    // Find the first unused layer starting from UserLayer0
    for (let i = 0; i < userLayers.length; i++) {
        const userLayer = userLayers[i];
        if (!Layers.isLayerUsed(userLayer)) {
            Layers.addLayer(layerName || UserLayers[userLayer], i);
            updateUnusedLayerCount();
            return userLayer;
        }
    }
    warn('All user layers are currently in use. No unused layer available.');
    return Layers.Enum.NONE;
};

Layers.freeLayer = function freeLayer(this: Layers, layer: number) {
    if (!Layers.isUserLayer(layer)) {
        warn(`Cannot free layer ${layer} which is not a user layer.`);
        return;
    }
    const bitNumber = Math.log2(layer);
    if (!Number.isInteger(bitNumber)) {
        warn(`Invalid layer value: ${layer}`);
        return;
    }
    Layers.deleteLayer(bitNumber);
    updateUnusedLayerCount();
};

Layers.isUserLayer = function isUserLayer(this: Layers, layer: number): boolean {
    return layer >= UserLayers.UserLayer0 && layer <= UserLayers.UserLayer19;
};

Layers.isLayerUsed = function isLayerUsed(this: Layers, layer: number): boolean {
    return layer in Layers.Enum;
};

function updateUnusedLayerCount() {
    Layers.unusedLayerCount = userLayers.reduce((count, layer) => count + (Layers.isLayerUsed(layer) ? 0 : 1), 0);
}
updateUnusedLayerCount();
